<template>
<div class="pass-verify">
  <input
    v-model="scanInput"
    name="scanInput"
    type="text"
    class="scanner-input"
    ref="scannerInput"
    autocomplete="off"
    autocapitalize="off"
    spellcheck="false"
    autofocus
    @keyup.enter="handleScan"
  />
  <div class="container header">
    <div class="row">
      <img src="../../../../public/img/konversta.png" alt class="img-logo" />
      <button class="btn btn-outline-primary btn-primary-blue" @click="logout">
        Выйти из кабинета
      </button>
    </div>
  </div>
  <div class="main-container">
    <div v-if="pass !== null" class="row hidden-md hidden-lg">
      <div class="col-xs-5 col-sm-4 avatar-container">
        <img :src="passAvatar" alt="avatar" class="avatar" />
      </div>
      <div class="col-xs-7 col-sm-8 field hidden-md hidden-lg">
        ФИО<br><span class="fw-bold" style="font-size: 16px">{{ pass.fullName }}</span>
      </div>
    </div>

    <div v-if="pass !== null" class="row">
      <div class="col-md-2 col-lg-3 hidden-xs hidden-sm avatar-container">
        <img :src="passAvatar" alt="avatar" class="avatar" />
      </div>

      <div class="col-md-6 col-lg-6 data-container">
        <div class="field hidden-xs hidden-sm">
          ФИО<br><span class="fw-bold" style="font-size: 16px">{{ pass.fullName }}</span>
        </div>

        <br>

        <div
          class="col-md-4 col-lg-3 hidden-md hidden-lg other-data-container"
          :style="{ 'border': passPeriodStatus === 'active' ? 'forestgreen 2px solid' : 'red 2px solid' }"
        >
          <div
            v-html="passPeriodText"
            class="pass-date"
            :style="{ 'color': passPeriodStatus !== 'active' ? 'red' : '' }"
          />
        </div>
        <br>

        <div class="field fw-bold identification-type-field">
          {{ pass.identificationType }}
        </div>
        <div class="field">Серия и номер<br><span class="fw-bold">{{ pass.identificationNumber }}</span></div>
        <div class="field">Кем выдан<br><span class="fw-bold">{{ pass.identificationPlace }}</span></div>
        <div class="field">Дата выдачи<br><span class="fw-bold">{{ pass.identificationDateOf }}</span></div>
        <div class="field">Дата рождения<br><span class="fw-bold">{{ pass.birthDay }}</span></div>
        <div class="field">Адрес регистрации<br><span class="fw-bold">{{ pass.registrationAddress }}</span></div>
      </div>

      <div
        class="col-md-4 col-lg-3 hidden-xs hidden-sm other-data-container"
        :style="{ 'border': passPeriodStatus === 'active' ? 'forestgreen 2px solid' : 'red 2px solid' }"
      >
        <div
          v-html="passPeriodText"
          class="pass-date"
          :style="{ 'color': passPeriodStatus !== 'active' ? 'red' : '' }"
        />
      </div>
    </div>
    <div v-else class="row">
      <div class="col-md-12 not-found-container">
        <img src="../../../../public/img/travolta.png" alt="not found pass image" class="not-found-img" />
        <h2 v-html="'Пропуск не&nbsp;найден'" class="fw-bold"></h2>
        <p>Попробуйте отсканировать ещё раз или используйте другой пропуск</p>
      </div>
    </div>
  </div>

  <div v-if="pass && userCanUse" class="row">
    <div class="col-md-12 fw-bold last-action-text">
      {{ lastActionText }}
    </div>
    <div v-if="visibleAllowButton" class="col-md-12 btn-container">
      <button class="btn btn-primary btn-primary-blue allow-btn" @click="allowAction">
        Разрешить {{ buttonTextByLastActionType }}
      </button>
    </div>
  </div>
</div>
</template>

<script>
import mainMixin from '@/common/mixins/mainMixin'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import '@/common/assets/styles/pass-verify.scss'
import PermissionsEnum from '@/common/enums/PermissionsEnum'
import PermissionsMixin from '@/common/mixins/PermissionsMixin'
import { ResponseStatuses } from '@/enums/ResponseStatuses'

export default {
  name: 'PassVerify',

  mixins: [mainMixin, PermissionsMixin],

  data() {
    return {
      baseUrl: window.location.origin + window.location.pathname,
      scanInput: '',
      showAllowButton: true,
      pass: {
        id: this.$route.query.passId,
        periodOf: '',
        periodTo: '',
        fullName: '',
        identificationType: '',
        identificationNumber: '',
        identificationPlace: '',
        identificationDateOf: '',
        birthDay: '',
        registrationAddress: '',
        avatar: '',
        lastActionType: '',
        lastActionDate: ''
      }
    }
  },

  computed: {
    buttonTextByLastActionType() {
      if (!this.pass || !['in', 'out'].includes(this.pass.lastActionType) || this.pass.lastActionType === 'out') {
        return 'вход'
      }

      return 'выход'
    },

    lastActionText() {
      if (this.pass.lastActionDate === null) {
        return ''
      }

      let lastActionText = 'Вход на территорию'
      if (this.pass.lastActionType === 'out') {
        lastActionText = 'Выход с территории'
      }

      return lastActionText + ' был ' + this.pass.lastActionDate.replace(' ', ' в ')
    },

    passAvatar() {
      return this.pass.avatar !== null ? this.pass.avatar : '../img/no_photo.png'
    },

    passPeriodStatus() {
      const now = new Date()
      const periodOf = new Date(this.getIsoDate(this.pass.periodOf))
      const periodTo = new Date(this.getIsoDate(this.pass.periodTo))

      if (now < periodOf) {
        return 'not_started'
      }

      if (periodTo < now) {
        return 'expired'
      }

      return 'active'
    },

    passPeriodText() {
      const periodOf = this.pass.periodOf.replace(' ', '&nbsp;')
      const periodTo = this.pass.periodTo.replace(' ', '&nbsp;')
      const datePeriod = '<span class="fw-bold">с&nbsp;' + periodOf + ' по&nbsp;' + periodTo + '</span>'

      let text = 'Пропуск действует'
      if (this.passPeriodStatus === 'not_started') {
        text = 'Не наступил срок действия пропуска'
      }

      if (this.passPeriodStatus === 'expired') {
        text = 'Истёк срок действия пропуска'
      }

      return text + '<br>' + datePeriod
    },

    userCanUse() {
      return this.hasPermission(PermissionsEnum.canUsePassVerifyPage)
    },

    visibleAllowButton() {
      return this.showAllowButton && this.passPeriodStatus === 'active'
    }
  },

  methods: {
    allowAction() {
      let action = 'in'
      if (this.pass.lastActionType === 'in') {
        action = 'out'
      }

      ApiClient.passAllowAction({ passId: this.pass.id, action: action })
        .then((result) => {
          if (result.data.status === 'success') {
            this.showAllowButton = false
            this.loadPage()
          }
        })
    },

    focusScanner() {
      this.$refs.scannerInput.focus()
    },

    handleScan() {
      const input = this.scanInput.trim()

      if (!input || !input.startsWith(this.baseUrl)) {
        this.scanInput = ''

        return
      }

      window.location.href = input

      this.scanInput = ''
    },

    getIsoDate(date) {
      const [datePart, timePart] = date.split(' ');
      const [day, month, year] = datePart.split('.');

      return `${year}-${month}-${day}T${timePart}`
    },

    async loadPage() {
      await ApiClient.getPassVerify({ passId: this.pass.id })
        .then((result) => {
          if (result.data.http_code === 200) {
            this.pass = result.data.data
          }
        })
    },

    logout () {
      ApiClient.logout()
        .then(response => {
          if (response.data.status === ResponseStatuses.Success) {
            this.$store.dispatch('flushAuthorize')
            window.location.reload()
          }
        })
    }
  },

  mounted() {
    this.loadPage()
    this.hidePreloader()
    document.addEventListener('click', this.focusScanner)
  }
}
</script>
